import styled from '@emotion/styled';
import { Magnetic } from "../../../styles";
export const StyledVideoDocument = styled('div') `
	color: ${Magnetic.actionableColor};
	font-size: ${Magnetic.videoPlayerIconSize};
`;
export const StyledVideoDownload = styled('div') `
	cursor: ${Magnetic.actionableCursor};
	font-size: ${Magnetic.videoPlayerIconSize};
	color: ${Magnetic.actionableColor};
`;
//# sourceMappingURL=VideoPlayer.style.js.map